var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCollapseToggle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 20C3.10457 20 4 19.1046 4 18C4 16.8954 3.10457 16 2 16C0.89543 16 0 16.8954 0 18C0 19.1046 0.89543 20 2 20Z",
    fill: "#E83647"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.12 16H9.88C8.8417 16 8 16.8417 8 17.88V18.12C8 19.1583 8.8417 20 9.88 20H34.12C35.1583 20 36 19.1583 36 18.12V17.88C36 16.8417 35.1583 16 34.12 16Z",
    fill: "#E83647"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.12 26H1.88C0.841705 26 0 26.8417 0 27.88V28.12C0 29.1583 0.841705 30 1.88 30H34.12C35.1583 30 36 29.1583 36 28.12V27.88C36 26.8417 35.1583 26 34.12 26Z",
    fill: "#E83647"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.12 6H1.88C0.841705 6 0 6.8417 0 7.88V8.12C0 9.1583 0.841705 10 1.88 10H34.12C35.1583 10 36 9.1583 36 8.12V7.88C36 6.8417 35.1583 6 34.12 6Z",
    fill: "#E83647"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapseToggle);
export default __webpack_public_path__ + "static/media/icon-collapse-toggle.5d681b7a9a4acc3a8f429eae5d770df6.svg";
export { ForwardRef as ReactComponent };